import './style/App.css';
import PostTile from './components/PostTile';
import NotFound from './NotFound';
import { topics, database } from './common/database';

import { useEffect } from "react";
import { useParams } from "react-router-dom";

function Home() {
    useEffect(() => {
        document.title = "Saba Imran"
    }, []);

    // Determine if the passed-in filter actually constitutes a valid filter for our dataset.
    function isValidTopic(option) {
        for (const [ , value ] of Object.entries(topics)) {
            if (value === option) {
                return true;
            }
        }
        return false;
    }

    let { topics: filter } = useParams();

    // Check if the filter passed in is valid.
    if (filter && !isValidTopic(filter)) {
        return <NotFound />;
    }

    // If there was no filter passed in using the /topics/ path in the query parameters, then show all the posts in the database.
    let posts = filter ? database.filter(post => post.topics.has(filter)) : database;

    return (
        <div className="posts-list">
            {posts.map((post) => 
                <PostTile
                    key={post.slug}
                    path={"/" + post.slug}
                    slug={post.slug}
                    title={post.title}
                    preview={post.preview}
                    topics={post.topics}
                    date={post.date}/>
            )}
        </div>
    );
}

export default Home;
